/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnContext } from './en-context';
import { EnPersonType } from './en-person-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateClientDto
 */
export interface UpdateClientDto {

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    companyName?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    registeredOfficeAddress?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    postalCode?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    city?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    province?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    nation?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateClientDto
     */
    place?: JoinEntityDto;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    telephone?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    email?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    vatNumber?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    pec?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    poc?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    cuuCode?: string;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    sdiCode?: string;

    /**
     * @type {EnPersonType}
     * @memberof UpdateClientDto
     */
    type?: EnPersonType;

    /**
     * @type {EnContext}
     * @memberof UpdateClientDto
     */
    context?: EnContext;

    /**
     * @type {string}
     * @memberof UpdateClientDto
     */
    note?: string;
}
